import { Component, OnInit, Input, Inject, ViewChild, Output, EventEmitter } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../shared/loader/loader.service';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { MULTIFACILITY_PHASE2 } from '../reusableclassesAndFunctions/constants';
import {
  ReferralAction, actionStateLabel, facilityStateLine, facilityAlreadyIn, facilityAlreadyHint,
  facilitiesAlreadyIn, facilitiesAlreadyText, rowStateLabel
} from '../referralDialog/facility-state';

@Component({
  selector: 'app-addemailForDeclineReferral',
  templateUrl: './addemailForDeclineReferral.component.html',
  styleUrls: ['./addemailForDeclineReferral.component.scss']
})

export class AddemailForDeclineReferralComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;  
  OfficeIDList: any = [];
  myOfficeID: any;
  spinner: boolean = false;  
  showAddButton = false;
  addUpdateParticipantList: any = [] = []; 
  emailAssigned: string = '';
  addEmailButtonShow: boolean = false;
  textButton:string="Decline";
  message:string="";
  personName:string="";
  textForPerson:string="";

  // External (portal-synced) referral: the decline is ALSO sent to the source
  // portal, which requires a live decline reason + a message to the hospital.
  isExternal: boolean = false;
  declineReasons: any[] = [];
  selectedDeclineReasonId: number | null = null;

  // Phase-2 rollout flag — provider picker hidden until MULTIFACILITY_PHASE2.
  mfPhase2 = MULTIFACILITY_PHASE2;

  // Multi-recipient referrals (portal "Update Responses" pattern): the Decline
  // is sent to the SELECTED recipient facilities only.
  providerOptions: any[] = [];
  selectedProviderKeys: { [key: string]: boolean } = {};

  constructor(private dialog: MatDialog, private dialog1: MatDialog, private datePipe: DatePipe, public dialogRef: MatDialogRef<AddemailForDeclineReferralComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService, private loaderService: LoaderService,
    private formsService: FormsService,) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  }

  ngOnInit(): void {
    if(this.data){
     this.showAddButton = true;
    }
    this.personName=this.data.selectedRecord.name;
    this.isExternal = !!this.data.selectedRecord.isExternal;
    if (this.isExternal) this.loadDeclineReasons();

    // Provider picker only when the referral reached 2+ recipient facilities.
    // NOTHING is pre-selected (client req) — the user must consciously choose
    // which facility the response applies to; the only exception is a per-site
    // action from the Recipients panel, which checks exactly that site.
    // Phase gating: picker is phase-2 everywhere — even per-site actions from
    // the Recipients panel open this classic popup until MULTIFACILITY_PHASE2.
    const fac = this.data.selectedRecord?.sharedFacilities || [];
    if (this.mfPhase2 && this.isExternal && fac.length > 1) {
      this.providerOptions = fac;
      if (this.data.preselectProviderKey) {
        this.selectedProviderKeys[this.data.preselectProviderKey] = true;
      }
    }
    //this.textForPerson = `This is to formally inform you that ${this.personName} has been declined.`;
    this.textForPerson = `This is to formally inform you that <b>${this.personName}</b> has been <b>declined</b>.`;
 
    if (this.data.selectedRecord.emails) {
      let emailList = this.data.selectedRecord.emails.split(',');
      emailList.forEach((email: string) => {
        email = email.trim();
        if (email !== "") {
          let toArray = email.split("@");
          let shortName = toArray[0].match(/\b(\w)/g)?.join('') || '';
          var obj = {
            name: "",
            email: email,
            img: "",
            shortName: shortName
          };
          this.addUpdateParticipantList.push(obj);
        }
      });

      // Reset input
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      if (this.addUpdateParticipantList.length > 0) {
        this.showAddButton = false;
        this.textButton = "FollowUp & Send Mail";
      } else {
        this.showAddButton = true;
      }
    }
  }


  removeParticipant(item: any) {
    const index = this.addUpdateParticipantList.indexOf(item);
    if (index >= 0) {
      this.addUpdateParticipantList.splice(index, 1);
    }
    if (this.addUpdateParticipantList.length > 0) {
      this.showAddButton = false;
      this.textButton="Decline & Send Mail";
    } else {
      this.showAddButton = true;
       this.textButton="Decline";
    }
  }


  //==== For Add Email================//

  addEmail() {
    var check = [];
    check = this.addUpdateParticipantList.filter((x:any) => x.email.toLowerCase() == this.emailAssigned.toLowerCase())

    let toArray = this.emailAssigned.split("@");
    var shortName = toArray[0].match(/\b(\w)/g).join('');
    if (check.length == 0) {
      var obj = {
        name: "",
        email: this.emailAssigned,
        img: "",
        shortName: shortName
      }
      this.addUpdateParticipantList.push(obj);
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      if (this.addUpdateParticipantList.length > 0) {
        this.showAddButton = false;
        this.textButton="Decline & Send Mail";
      } else {
        this.showAddButton = true;
        this.textButton="Decline";
      }
    } else {
      this.emailAssigned = "";
      this.addEmailButtonShow = false;
      this.toastr.warning('Email allready added.', '', {
        timeOut: 3000,
      });
    }
  }

  emailCheck(searchValue: any) {
    if (searchValue.toLowerCase() == searchValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')) {
      this.emailAssigned = searchValue;
      this.addEmailButtonShow = true;
    } else {
      this.addEmailButtonShow = false;
    }
  }

  // Decline reasons come live from the source portal — never hard-coded.
  loadDeclineReasons() {
    // Sync off → the reason grid is hidden (nothing goes to the portal).
    if (this.data?.portalSyncOff) { this.declineReasons = []; return; }
    const req = {
      referralD: Number(this.data.selectedRecord.referralID),
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: Number(this.myOfficeID)
    };
    this.formsService.getExternalDeclineReasons(req).subscribe({
      next: (response: any) => { this.declineReasons = response?.data || []; },
      error: () => { this.declineReasons = []; }
    });
  }

  // ── Provider picker helpers ──
  provKey(f: any): string { return (f.providerAdmissionRequestId || '') + '|' + (f.facilityName || ''); }
  // Sibling facilities need the portal's providerAdmissionRequestId to be
  // targeted — payloads synced before v8 lack it (resync fills it in).
  // Facility access rule (canAct is computed by the list): facilities whose office
  // the user cannot enter are shown but cannot be selected.
  // Facility state (2026-09-25): every facility shows its CURRENT state (who · when);
  // a facility that is ALREADY Declined cannot be selected — the hospital already
  // has that answer, so re-sending it is blocked with a message instead.
  readonly action: ReferralAction = 'decline';
  actionLabel(): string { return actionStateLabel(this.action); }
  stateLine(f: any): string { return facilityStateLine(f); }
  alreadyIn(f: any): boolean { return facilityAlreadyIn(f, this.action); }
  alreadyList(): any[] { return facilitiesAlreadyIn(this.providerOptions, this.action); }
  alreadyText(): string { return facilitiesAlreadyText(this.providerOptions, this.action); }
  allAlready(): boolean { return this.providerOptions.length > 0 && this.alreadyList().length === this.providerOptions.length; }
  rowState(): string { return rowStateLabel(this.data?.selectedRecord); }

  providerDisabled(f: any): boolean {
    return f?.canAct === false || this.alreadyIn(f) || (!f.isMine && !f.providerAdmissionRequestId);
  }
  providerHint(f: any): string {
    if (f?.canAct === false) return 'You do not have access to this facility\'s office';
    if (this.alreadyIn(f)) return facilityAlreadyHint(f, this.action);
    return this.providerDisabled(f) ? 'Sync this referral again to enable responding for this facility' : '';
  }
  selectedProviders(): any[] {
    return this.providerOptions.filter((f: any) => this.selectedProviderKeys[this.provKey(f)]);
  }
  canSubmitProviders(): boolean {
    return !this.providerOptions.length || (this.selectedProviders().length > 0 && !this.allAlready());
  }

  declineAndSendMail() {
    if (this.allAlready()) {
      this.toastr.warning('Every facility on this referral is already Declined — nothing new to send.', '', { timeOut: 3500 });
      return;
    }
    // The portal demands a reason with every Decline (message is optional —
    // only Request More Info requires one). With the user's portal sync OFF the
    // decline is Flowtrics-only, so no portal reason is needed.
    const localOnly = !!this.data?.portalSyncOff;
    if (this.isExternal && !localOnly && !this.selectedDeclineReasonId) {
      this.toastr.warning('Select a decline reason — the hospital portal requires one.', '', { timeOut: 3000 });
      return;
    }
    // Portal pattern: no action until at least one recipient is selected.
    if (!this.canSubmitProviders()) {
      this.toastr.warning('Select at least one facility this Decline applies to.', '', { timeOut: 3000 });
      return;
    }

    const emails: string[] = this.addUpdateParticipantList?.map(x =>
     x.email?.trim()).filter(email => !!email) || [];

    var ReqModel={
      referralD: Number(this.data.selectedRecord.referralID),
      message: this.textForPerson + "<br><br>" + this.message?.trim(),
      emails: emails,
      locationID: 0,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: Number(this.myOfficeID),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
      // External rows: push the decline (reason + plain message) to the portal too.
      pushToSource: this.isExternal,
      declineReasonId: this.isExternal ? this.selectedDeclineReasonId : null,
      portalMessage: this.message?.trim() || '',
      // Multi-recipient: the selected providers; null = single-recipient flow.
      targetProviders: this.providerOptions.length
        ? this.selectedProviders().map((f: any) => ({
            providerAdmissionRequestId: '' + (f.providerAdmissionRequestId || ''),
            providerId: '' + (f.providerId || ''),
            facilityName: f.facilityName || '',
            isMine: !!f.isMine
          }))
        : null
    }
   //return;
    this.spinner=true;    
    this.loaderService.show();
   this.settingsService.declineReferralQueue(ReqModel).subscribe(response => {
   if (response != undefined) {
      this.responseHolder = response;    
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.spinner=false;
        this.loaderService.hide();
        this.dialogRef.close('Added');
        if (this.isExternal && this.data?.portalSyncOff) {
          // Declined in Flowtrics only — the server skipped the portal push
          // because this user's CarePort sync is off.
          this.toastr.warning('Declined in Flowtrics only — your CarePort sync is off, the hospital was NOT notified.', '', { timeOut: 5000 });
        } else if ((this.responseHolder.message || '').indexOf('FAILED') >= 0) {
          // Multi-provider partial failure — name who did not get the response.
          this.toastr.warning(this.responseHolder.message, '', { timeOut: 7000 });
        } else {
          this.toastr.success('Selected referral decline successfully.', '', {
           timeOut: 3000,
          });
        }
       }else{
        this.spinner=false;
        this.loaderService.hide();
        // Portal rejections (bad reason, source down) surface here — show why.
        this.toastr.error(this.responseHolder.message || 'Decline failed.', '', { timeOut: 4000 });
       }
     }else{     
      this.spinner=false; 
      this.loaderService.hide(); 
     }
   });
  }

  close() {
    this.dialogRef.close();
  }


}
